var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1403_63547)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 19.375H12.5V18.125C12.5 17.78 12.78 17.5 13.125 17.5H16.875C17.22 17.5 17.5 17.78 17.5 18.125V19.375H18.75V18.125C18.75 17.0912 17.9088 16.25 16.875 16.25H13.125C12.0912 16.25 11.25 17.0912 11.25 18.125V19.375Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 11.875C14.3106 11.875 13.75 12.4356 13.75 13.125C13.75 13.8144 14.3106 14.375 15 14.375C15.6894 14.375 16.25 13.8144 16.25 13.125C16.25 12.4356 15.6894 11.875 15 11.875ZM15 15.625C13.6212 15.625 12.5 14.5038 12.5 13.125C12.5 11.7462 13.6212 10.625 15 10.625C16.3788 10.625 17.5 11.7462 17.5 13.125C17.5 14.5038 16.3788 15.625 15 15.625Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.25 19.375H2.5V18.125C2.5 17.78 2.78062 17.5 3.125 17.5H6.875C7.21938 17.5 7.5 17.78 7.5 18.125V19.375H8.75V18.125C8.75 17.0912 7.90875 16.25 6.875 16.25H3.125C2.09125 16.25 1.25 17.0912 1.25 18.125V19.375Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 11.875C4.31062 11.875 3.75 12.4356 3.75 13.125C3.75 13.8144 4.31062 14.375 5 14.375C5.68937 14.375 6.25 13.8144 6.25 13.125C6.25 12.4356 5.68937 11.875 5 11.875ZM5 15.625C3.62125 15.625 2.5 14.5038 2.5 13.125C2.5 11.7462 3.62125 10.625 5 10.625C6.37875 10.625 7.5 11.7462 7.5 13.125C7.5 14.5038 6.37875 15.625 5 15.625Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 10H12.5V8.75C12.5 8.40562 12.78 8.125 13.125 8.125H16.875C17.22 8.125 17.5 8.40562 17.5 8.75V10H18.75V8.75C18.75 7.71625 17.9088 6.875 16.875 6.875H13.125C12.0912 6.875 11.25 7.71625 11.25 8.75V10Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 2.5C14.3106 2.5 13.75 3.06062 13.75 3.75C13.75 4.43937 14.3106 5 15 5C15.6894 5 16.25 4.43937 16.25 3.75C16.25 3.06062 15.6894 2.5 15 2.5ZM15 6.25C13.6212 6.25 12.5 5.12875 12.5 3.75C12.5 2.37125 13.6212 1.25 15 1.25C16.3788 1.25 17.5 2.37125 17.5 3.75C17.5 5.12875 16.3788 6.25 15 6.25Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.25 10H2.5V8.75C2.5 8.40562 2.78062 8.125 3.125 8.125H6.875C7.21938 8.125 7.5 8.40562 7.5 8.75V10H8.75V8.75C8.75 7.71625 7.90875 6.875 6.875 6.875H3.125C2.09125 6.875 1.25 7.71625 1.25 8.75V10Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 2.5C4.31062 2.5 3.75 3.06062 3.75 3.75C3.75 4.43937 4.31062 5 5 5C5.68937 5 6.25 4.43937 6.25 3.75C6.25 3.06062 5.68937 2.5 5 2.5ZM5 6.25C3.62125 6.25 2.5 5.12875 2.5 3.75C2.5 2.37125 3.62125 1.25 5 1.25C6.37875 1.25 7.5 2.37125 7.5 3.75C7.5 5.12875 6.37875 6.25 5 6.25Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1403_63547"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.c33c4406b13122fdf1f199f2534db112.svg";
export { ForwardRef as ReactComponent };